import { gsap } from "gsap";

class VideoPreloader {
  constructor(callback) {
    this.callback = callback;
    this.videos = [];
    this.loadedVideos = 0;
    this.totalVideos = 0;
    // Bind the event handler once to use the same reference for add/remove
    this._handleVideoCanPlayThrough =
      this._handleVideoCanPlayThrough.bind(this);
    this._handleVideoError = this._handleVideoError.bind(this); // Optional: bind error handler too
    this._initialize();
  }

  _initialize() {
    this.videos = Array.from(document.querySelectorAll("video"));
    this.totalVideos = this.videos.length;

    if (this.totalVideos === 0) {
      this._preloadComplete();
      return;
    }

    this.videos.forEach((video) => {
      // 1. Force attributes Safari requires for background loading
      video.muted = true;
      video.setAttribute("playsinline", "");
      video.preload = "auto";

      // 2. Listen for 'loadedmetadata' instead of 'canplaythrough'
      // Safari is much more consistent with this event.
      video.addEventListener(
        "loadedmetadata",
        this._handleVideoCanPlayThrough,
        { once: true }
      );
      video.addEventListener("error", this._handleVideoError, { once: true });

      video.load();
    });

    // 3. FAILSAFE: If Safari stalls, trigger the callback anyway after 5 seconds
    // This prevents your site from being stuck on a loading screen forever.
    setTimeout(() => {
      if (this.loadedVideos < this.totalVideos) {
        console.warn("Preload timed out. Proceeding with available videos.");
        this._preloadComplete();
      }
    }, 5000);
  }

  _handleVideoCanPlayThrough(event) {
    // console.log(`Video loaded: ${event.target.src}`);
    this.loadedVideos++;
    // Remove the listener once the video is ready to prevent multiple triggers if {once: true} wasn't used
    // event.target.removeEventListener("canplaythrough", this._handleVideoCanPlayThrough);

    if (this.loadedVideos === this.totalVideos) {
      this._preloadComplete();
    }
  }

  _handleVideoError(event) {
    console.error("Error preloading video:", event.target.src, event);
    // DECISION: How to handle errors?
    // Option A: Treat as loaded to not block the main callback if some videos fail.
    // this.loadedVideos++;
    // if (this.loadedVideos === this.totalVideos) {
    //   this._preloadComplete();
    // }
    // Option B: Acknowledge failure, maybe trigger callback with an error status.
    // For now, it just logs and still waits for others.
  }

  _preloadComplete() {
    // Clean up all event listeners for all videos
    this.videos.forEach((video) => {
      video.removeEventListener(
        "canplaythrough",
        this._handleVideoCanPlayThrough
      );
      video.removeEventListener("error", this._handleVideoError);
    });
    if (window.debug) {
      console.log(
        `All ${this.loadedVideos}/${this.totalVideos} videos preloaded.`
      );
    }
    this.callback();
  }
}

export { VideoPreloader };
